exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-menu-item,\n:host {\n  position: relative;\n  width: 430px;\n  display: block;\n  height: 100vh;\n  overflow: hidden;\n}\ndiv.layer-manager {\n  width: 100%;\n  margin: 0 0 20px 0;\n  box-sizing: border-box;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/layers-manager/components/layers-manager/layers-manager.component.less
// module id = ../../../../../src/app/packages/menu-items/layers-manager/components/layers-manager/layers-manager.component.less
// module chunks = main